import { useTranslation } from 'react-i18next';
import { mdiApi } from '@mdi/js';
import { Box, Typography } from '@mui/material';

import { ILinkModuleListItemFragment } from 'graphql/types';
import { TTrainingModuleProps } from 'training/types';
import { Link } from 'common/components/Link';
import { Icon } from 'common/components/Icon';
import { ListFooter } from 'common/components/ListFooter';
import { ActionButton } from 'common/components/ActionButton';

export const WebhookModule = ({
    id,
    trainingId,
}: TTrainingModuleProps<ILinkModuleListItemFragment>) => {
    const [translate] = useTranslation();

    return (
        <ListFooter
            button={false}
            component={Link}
            params={{
                trainingId,
                moduleId: id,
                type: 'webhook',
            }}
            sx={{
                backgroundColor: 'grey.100',
            }}
            to="TRAINING_UPDATE_MODULE"
        >
            <ActionButton
                outlined
                aria-labelledby="webhookTrigger"
                size="medium"
            >
                <Icon path={mdiApi} size="2.4rem" />
            </ActionButton>
            <Box sx={{ ml: 2 }}>
                <Typography id="webhookTrigger">
                    {translate('webhookTrigger')}
                </Typography>
            </Box>
        </ListFooter>
    );
};
